/**
 * スムーススクロール
 * - 固定ヘッダーあり / なし 切り替え可
 * - 同一ページ内リンク対応
 * - 他ページからのハッシュ遷移対応
 */
(function () {
	'use strict';

	const config = {
		// 固定ヘッダーがあるか
		hasHeader: true,

		// 固定ヘッダー要素
		headerSelector: '.l-header',

		// 追加でずらしたい余白
		offset: 0,

		// スクロール発火を少し遅らせる時間
		// 他ページからのハッシュ遷移時にレイアウト確定待ちしたい時用
		delay: 100
	};

	/**
	 * ヘッダー高さ取得
	 */
	function getHeaderHeight() {
		if (!config.hasHeader) return 0;

		const header = document.querySelector(config.headerSelector);
		return header ? header.offsetHeight : 0;
	}

	/**
	 * スクロール位置計算
	 * @param {Element} target
	 * @returns {number}
	 */
	function getScrollPosition(target) {
		const headerHeight = getHeaderHeight();
		const position = target.getBoundingClientRect().top + window.scrollY;
		return position - headerHeight - config.offset;
	}

	/**
	 * 対象へスムーススクロール
	 * @param {Element} target
	 */
	function smoothScroll(target) {
		if (!target) return;

		const top = getScrollPosition(target);

		window.scrollTo({
			top: top,
			behavior: 'smooth'
		});
	}

	/**
	 * hrefからターゲット取得
	 * @param {string} href
	 * @returns {Element|null}
	 */
	function getTarget(href) {
		if (!href || href === '#') {
			return document.documentElement;
		}

		try {
			return document.querySelector(href);
		} catch (error) {
			return null;
		}
	}

	/**
	 * 同一ページ内リンククリック対応
	 */
	function handleAnchorClick() {
		const anchors = document.querySelectorAll('a[href*="#"]');

		anchors.forEach(function (anchor) {
			anchor.addEventListener('click', function (event) {
				const url = new URL(this.href, window.location.href);

				// 別ページへのリンクはそのまま遷移
				if (
					url.pathname !== window.location.pathname ||
					url.origin !== window.location.origin
				) {
					return;
				}

				const hash = url.hash;
				if (!hash) return;

				const target = getTarget(hash);
				if (!target) return;

				event.preventDefault();

				history.pushState(null, '', hash);
				smoothScroll(target);
			});
		});
	}

	/**
	 * 他ページからハッシュ付きで来た場合の対応
	 */
	function handleInitialHash() {
		if (!window.location.hash) return;

		const target = getTarget(window.location.hash);
		if (!target) return;

		window.setTimeout(function () {
			smoothScroll(target);
		}, config.delay);
	}

	handleAnchorClick();
	window.addEventListener('load', handleInitialHash);
})();



	/*
	* css swicher
	*/

	function css_browser_selector(u) {
		var ua = u.toLowerCase(),
			is = function (t) { return ua.indexOf(t) > -1 },
			e = 'edge', g = 'gecko', w = 'webkit', s = 'safari', o = 'opera', m = 'mobile',
			h = document.documentElement,
			b = [
				(!(/opera|webtv/i.test(ua)) && /msie\s(\d)/.test(ua)) ? ('ie ie' + RegExp.$1) :
					!(/opera|webtv/i.test(ua)) && is('trident') && /rv:(\d+)/.test(ua) ? ('ie ie' + RegExp.$1) :
						is('edge/') ? e :
							is('firefox/2') ? g + ' ff2' :
								is('firefox/3.5') ? g + ' ff3 ff3_5' :
									is('firefox/3.6') ? g + ' ff3 ff3_6' : is('firefox/3') ? g + ' ff3' :
										is('gecko/') ? g :
											is('opera') ? o + (/version\/(\d+)/.test(ua) ? ' ' + o + RegExp.$1 :
												(/opera(\s|\/)(\d+)/.test(ua) ? ' ' + o + RegExp.$2 : '')) :
												is('konqueror') ? 'konqueror' :
													is('blackberry') ? m + ' blackberry' :
														is('android') ? m + ' android' :
															is('chrome') ? w + ' chrome' :
																is('iron') ? w + ' iron' :
																	is('applewebkit/') ? w + ' ' + s + (/version\/(\d+)/.test(ua) ? ' ' + s + RegExp.$1 : '') :
																		is('mozilla/') ? g :
																			'',
				is('j2me') ? m + ' j2me' :
					is('iphone') ? m + ' iphone' :
						is('ipod') ? m + ' ipod' :
							is('ipad') ? m + ' ipad' :
								is('mac') ? 'mac' :
									is('darwin') ? 'mac' :
										is('webtv') ? 'webtv' :
											is('win') ? 'win' + (is('windows nt 6.0') ? ' vista' : '') :
												is('freebsd') ? 'freebsd' :
													(is('x11') || is('linux')) ? 'linux' :
														'',
				'js'];
		c = b.join(' ');
		h.className += ' ' + c;
		return c;
	};
	css_browser_selector(navigator.userAgent);